import {IComponentOptions, IScope} from 'angular';
import AuthServiceRS from '../../../authentication/service/AuthServiceRS.rest';
import AbstractGesuchViewController from '../../../gesuch/component/abstractModelController';
import {TSDocumentType} from '../../../models/enums/TSDokumentType';
import {TSEigentumsverhaeltnis} from '../../../models/enums/TSEigentumsverhaeltnis';
import {TSErfassungsArt} from '../../../models/enums/TSErfassungsArt';
import {getTSRechtsformValues, getTSRechtsformValuesForZweitpersonGrundeigentuemer, TSRechtsform} from '../../../models/enums/TSRechtsform';
import {TSRole} from '../../../models/enums/TSRole';
import {getTSSchadenfallStatusNeu, TSSchadenfallStatus} from '../../../models/enums/TSSchadenfallStatus';
import {getTSSpracheValues, TSSprache} from '../../../models/enums/TSSprache';
import TSAdresse from '../../../models/TSAdresse';
import TSGenossenschaft from '../../../models/TSGenossenschaft';
import TSGenossenschaftDaten from '../../../models/TSGenossenschaftDaten';
import TSGesuchsPerson from '../../../models/TSGesuchsPerson';
import TSGesuchsPersonDaten from '../../../models/TSGesuchsPersonDaten';
import TSGesuchsteller from '../../../models/TSGesuchsteller';
import TSKoerperschaft from '../../../models/TSKoerperschaft';
import TSKoerperschaftDaten from '../../../models/TSKoerperschaftDaten';
import DateUtil from '../../../utils/DateUtil';
import DVBernUtil from '../../../utils/DVBernUtil';
import moment from 'moment';
import {BerechnungsdetailController} from '../../dialog/BerechnungsdetailController';
import {DvDialog} from '../../directive/dv-dialog/dv-dialog';
import RoleUtilService from '../../service/RoleUtilService';
import IFormController = angular.IFormController;
import ITranslateService = angular.translate.ITranslateService;
import TSUser from '../../../models/TSUser';

declare let require: any;
declare let angular: any;

let berechnungsTemplate = require('../../../core/dialog/berechnungsDetail.html');
require('./dv-gesuchsteller.scss');

export class GesuchstellerComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        model: '=',
        eigentumsverhaeltnis: '=',
        name: '@',
        prefix: '@',
        erfassungsart: '<',
        versicherungsmode: '<',
        status: '<',
        schadenfallId: '<',
        schadendatum: '<',
        ermittelterSchaden: '<',
        emailNotRequired: '<?', //damit man einstellen kann ob email ein Pflichtfeld ist
        phoneRequired: '<?', //damit man einstellen kann ob phone ein Pflichtfeld ist
        importiert: '<',
    };
    template = require('./dv-gesuchsteller.html');
    controller = DvGesuchstellerController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DvGesuchstellerController extends AbstractGesuchViewController<TSGesuchsteller> {

    static $inject = ['AuthServiceRS', 'DvDialog', 'RoleUtilService', '$translate', '$scope', 'DVBernUtil'];

    name: string;
    prefix: string;
    form: IFormController;
    erfassungsart: TSErfassungsArt | undefined;
    versicherungsmode: boolean;
    status: TSSchadenfallStatus | undefined;
    doctype: TSDocumentType = TSDocumentType.GESUCHSTELLER_DOC;
    dokumentNeededMap = {};
    schadenfallId: string;
    currentYear: number;
    emailNotRequired: boolean;
    phoneRequired: boolean;
    importiert: boolean = false;
    schadendatum: moment.Moment | undefined;
    ermittelterSchaden: number;

    /* @ngInject */
    constructor(
        private authServiceRS: AuthServiceRS, private dvDialog: DvDialog,
        private roleUtilService: RoleUtilService, private $translate: ITranslateService,
        $scope: IScope,
        private dvBernUtil: DVBernUtil,
    ) {
        super($scope);
        this.currentYear = DateUtil.currentYear();
    }

    $onInit() {
        this.changedEigentumsverhaeltinis();
        this.$scope.$watch(() => this.model.eigentumsverhaeltnis, (val: any) => {
            this.changedEigentumsverhaeltinis();
        });
        if (this.model.isZweitperson) {
            this.doctype = TSDocumentType.ZWEITPERSON_DOC;
        }
        this.loadDokumentNeededMap();
    }

    private loadDokumentNeededMap() {
        // Bei Versicherungsbeitrag nie Dokumente hochladen!
        if (!this.versicherungsmode) {
            // second parameter is if required

            const isSteuerpflichtig = this.isSteuerpflichtigeRechtsform(this.model);

            if (!this.model.isZweitperson) {
                // Gesuchsteller paechter
                if (this.model.eigentumsverhaeltnis === TSEigentumsverhaeltnis.PAECHTER) {
                    this.dokumentNeededMap[TSRechtsform.NATUERLICHE_PERSON] = [['PACHTVERTRAG', false]];
                    this.dokumentNeededMap[TSRechtsform.GENOSSENSCHAFT] = [['MITGLIEDERVERZEICHNIS', true], ['JAHRESRECHNUNG', false], ['PACHTVERTRAG', false]];
                    this.dokumentNeededMap[TSRechtsform.ANDERE_KOERPERSCHAFT] = [];
                    this.dokumentNeededMap[TSRechtsform.MEHRPERSONENGESELLSCHAFT] = [['STEUERFAKTOREN', true], ['PACHTVERTRAG', false]];
                } else {
                    // gesuchsteller grundeigentuemer
                    this.dokumentNeededMap[TSRechtsform.NATUERLICHE_PERSON] = [];
                    this.dokumentNeededMap[TSRechtsform.GENOSSENSCHAFT] = [['MITGLIEDERVERZEICHNIS', true], ['JAHRESRECHNUNG', false]];
                    this.dokumentNeededMap[TSRechtsform.ANDERE_KOERPERSCHAFT] = [];
                    this.dokumentNeededMap[TSRechtsform.MEHRPERSONENGESELLSCHAFT] = [['STEUERFAKTOREN', true]];
                }
            } else {
                // zweitperson paechter
                if (this.model.eigentumsverhaeltnis === TSEigentumsverhaeltnis.PAECHTER) {
                    this.dokumentNeededMap[TSRechtsform.NATUERLICHE_PERSON] = [['PACHTVERTRAG', false]];
                    this.dokumentNeededMap[TSRechtsform.GENOSSENSCHAFT] = [['PACHTVERTRAG', false]];
                    this.dokumentNeededMap[TSRechtsform.ANDERE_KOERPERSCHAFT] = [];
                    this.dokumentNeededMap[TSRechtsform.MEHRPERSONENGESELLSCHAFT] = [['PACHTVERTRAG', false]];
                } else {  //zweitperson grundeigentuemer
                    this.dokumentNeededMap[TSRechtsform.NATUERLICHE_PERSON] = [];
                    this.dokumentNeededMap[TSRechtsform.GENOSSENSCHAFT] = [];
                    this.dokumentNeededMap[TSRechtsform.ANDERE_KOERPERSCHAFT] = [];
                    this.dokumentNeededMap[TSRechtsform.MEHRPERSONENGESELLSCHAFT] = [];
                }
            }
        }
    }

    /**
     * gibt moegliche rechtsfromen zurueck
     */
    private getTSRechtsformen(): Array<TSRechtsform> {
        if ((this.model.isZweitperson && this.model.eigentumsverhaeltnis === TSEigentumsverhaeltnis.GRUNDEIGENTUEMER)
            || this.importiert) {
            return getTSRechtsformValuesForZweitpersonGrundeigentuemer();
        } else {
            return getTSRechtsformValues();
        }
    }

    private changedEigentumsverhaeltinis(): void {
        if (this.model && this.model && this.model.eigentumsverhaeltnis) {
            this.loadDokumentNeededMap();
        }

        this.resetErrors();
    }

    private resetErrors() {
        if (this.form) {
            this.form.$setPristine();
            this.form.$setUntouched();
        }
    }

    private changedRechtsform(): void {
        if (this.model && this.model && this.model.rechtsform) {
            this.initGesuchsteller(this.model);
            this.loadDokumentNeededMap();
        }
        this.resetErrors();
    }

    private initGesuchsteller(gesuchsteller: TSGesuchsteller) {
        switch (gesuchsteller.rechtsform) {
            case TSRechtsform.NATUERLICHE_PERSON:
                this.createGesuchsPersonDaten(gesuchsteller);
                //adresse wird hier benoetigt
                if (this.model.kontaktperson && !this.model.kontaktperson.gesuchsPersonDatenFS.adresse) {
                    this.model.kontaktperson.gesuchsPersonDatenFS.adresse = new TSAdresse();
                }
                break;
            case TSRechtsform.MEHRPERSONENGESELLSCHAFT:
            case TSRechtsform.GENOSSENSCHAFT:
                this.createGesuchsPersonDaten(gesuchsteller);
                if (!gesuchsteller.genossenschaft) {
                    gesuchsteller.genossenschaft = new TSGenossenschaft();
                    gesuchsteller.genossenschaft.genossenschaftDatenFS = new TSGenossenschaftDaten();
                }
                break;
            case TSRechtsform.ANDERE_KOERPERSCHAFT:
                this.createGesuchsPersonDaten(gesuchsteller);
                if (!gesuchsteller.koerperschaft) {
                    gesuchsteller.koerperschaft = new TSKoerperschaft();
                    gesuchsteller.koerperschaft.koerperschaftDatenFS = new TSKoerperschaftDaten();
                }
                break;
            default:
        }
    }

    private createGesuchsPersonDaten(gesuchsteller: TSGesuchsteller) {
        if (!gesuchsteller.kontaktperson) {
            gesuchsteller.kontaktperson = new TSGesuchsPerson();
            gesuchsteller.kontaktperson.gesuchsPersonDatenFS = new TSGesuchsPersonDaten();
            // set default email if Role is Betroffener
            if (this.isFillingOwnData()) {
                this.preFillDataOfPrincipal(gesuchsteller.kontaktperson.gesuchsPersonDatenFS);

            }
        }
    }

    // die ausfuellende Person ist der Gesuchsteller selber
    private isFillingOwnData() {
        return this.authServiceRS.isRole(TSRole.BETROFFENER) && this.prefix === 'gesuchsteller'
    }

    private preFillDataOfPrincipal(gesuchsPersonDatenFS: TSGesuchsPersonDaten) {
        let principal = this.authServiceRS.getPrincipal();
        if (principal) {
            if (principal.email) {
                gesuchsPersonDatenFS.mail = principal.email;
            }
            if (principal.vorname) {
                gesuchsPersonDatenFS.vorname = principal.vorname;
            }
            if (principal.nachname) {
                gesuchsPersonDatenFS.nachname = principal.nachname;
            }
        }
    }

    private checkRechtsform(rechtsform: TSRechtsform): boolean {
        return rechtsform === this.model.rechtsform;
    }

    private getTSSpracheValues(): Array<TSSprache> {
        return getTSSpracheValues();
    }

    private getMinimalSchaden(ermittelterSchaden: number, schadendatum: moment.Moment): number {
        return Math.round(this.getEinkommensabzug() + this.getVermoegenssabzug(ermittelterSchaden, schadendatum) + this.getAnrechenbarerSchaden());
    }

    public getEinkommensabzug(): number {
        return this.model.getEinkommensabzug();
    }

    public getVermoegenssabzug(ermittelterSchaden: number, schadendatum: moment.Moment): number {
        return this.model.getVermoegenssabzug(schadendatum, ermittelterSchaden);
    }

    public getGesamtAbzug(ermittelterSchaden: number): number {
        return this.getVermoegenssabzug(ermittelterSchaden, this.schadendatum!) + this.getEinkommensabzug();
    }

    private MRound(number: number, roundto: number) {
        return roundto * Math.round(number / roundto);
    }

    private isBerechtigtEinkommen(): boolean {
        if (this.model.hasFinanzangaben() &&
            DVBernUtil.isNotNullOrUndefined(this.model.finanzangaben!.finanzangabenDatenFS.einkommenGewinn)) {
            if (this.model.finanzangaben!.finanzangabenDatenFS.einkommenGewinn < 200000) {
                return true;
            }
        }
        return false;
    }

    private getMinimalSchadenVermoegenText(): string {
        if (this.schadendatum === null || this.schadendatum === undefined || this.schadendatum.isAfter(TSGesuchsteller.POST_2025_START_DATE, 'day')) {
            return 'MINIMAL_SCHADEN_VERMOEGEN_2026';
        } else {
            return'MINIMAL_SCHADEN_VERMOEGEN';
        }
    }

    private isBerechtigtVermoegen(): boolean {
        const wealthThreshold =
            this.schadendatum === null ||
            this.schadendatum === undefined ||
            this.schadendatum.isAfter(TSGesuchsteller.POST_2025_START_DATE, 'day') ?
                TSGesuchsteller.MAX_VERMOEGEN_KAPITAL_POST_2025 :
                TSGesuchsteller.MAX_VERMOEGEN_KAPITAL_PRE_2026;

        if (this.model.hasFinanzangaben() &&
            DVBernUtil.isNotNullOrUndefined(this.model.finanzangaben!.finanzangabenDatenFS.vermoegenKapital)) {
            if (this.model.finanzangaben!.finanzangabenDatenFS.vermoegenKapital < wealthThreshold) {
                return true;
            }
        }
        return false;
    }

    private getAnrechenbarerSchaden() {
        if (this.model && this.model &&
            (this.model.rechtsform === TSRechtsform.GENOSSENSCHAFT ||
                this.model.rechtsform === TSRechtsform.ANDERE_KOERPERSCHAFT)) {
            return 1000;
        }
        return 300;
    }

    public openBerechnungsdetail(): void {

        let vermoegenKapital = this.model.hasFinanzangaben() ? this.model.finanzangaben!.finanzangabenDatenFS.vermoegenKapital : undefined;
        let einkommenGewinn = this.model.hasFinanzangaben() ? this.model.finanzangaben!.finanzangabenDatenFS.einkommenGewinn : undefined;
        this.dvDialog.showBerechnungsDetail(berechnungsTemplate, BerechnungsdetailController, {
            einkommensabzug: this.getEinkommensabzug(),
            vermoegensabzug: this.getVermoegenssabzug(this.ermittelterSchaden, this.schadendatum!),
            anrechenbarerschaden: this.getAnrechenbarerSchaden(),
            minimalschaden: this.getMinimalSchaden(this.ermittelterSchaden, this.schadendatum!),
            steuerbaresvermoegen: vermoegenKapital,
            steuerbareseinkommen: einkommenGewinn,
        }).then(() => {
            //do nothing
        }).catch(() => {
        });
    }

    public getRolesAllowedForSteuerdaten(): Array<TSRole> {
        return this.dvBernUtil.getRolesAllowedForSteuerdaten();
    }

    public getRolesAllowedForSteuerdatenPruefung(): Array<TSRole> {
        //FS Admin und Anlaufstelle (nicht aber FS Sachbearbeiter, Schaetzer oder Betroffene)
        return this.roleUtilService.getRolesAllowedForAnlaufstellenPruefung();
    }

    public getZustimmungGesuchstellerReadonly(): boolean {
        return !this.authServiceRS.isOneOfRoles(this.roleUtilService.getGesuchstellerOnlyRoles()) && !(this.erfassungsart === TSErfassungsArt.PAPIER);
    }

    public showZustimmungSteuerpruefung(): boolean {
        return !(this.erfassungsart === TSErfassungsArt.PAPIER);
    }

    public getZustimmungSteuerpruefungText(): string {
        if (this.model.rechtsform === TSRechtsform.GENOSSENSCHAFT) {
            return this.$translate.instant('ZUSTIMMUNG_STEUERPRUEFUNG_GENOSSENSCHAFT');
        } else {
            return this.$translate.instant('ZUSTIMMUNG_STEUERPRUEFUNG');
        }
    }

    public getZustimmungPruefungFondsuisseText(): string {
        if (this.model.rechtsform === TSRechtsform.GENOSSENSCHAFT) {
            return this.$translate.instant('ZUSTIMMUNG_PRUEFUNG_FONDSUISSE_GENOSSENSCHAFT');
        } else {
            return this.$translate.instant('ZUSTIMMUNG_PRUEFUNG_FONDSUISSE');
        }
    }

    public clearSteuerdatenGeprueft() {
        if (this.model.finanzangaben) {
            this.model.finanzangaben.steuerdatenGeprueft = false;
        }
    }

    public isSchadenFallNeuOnlineOderNeuPapier() {
        if (this.status) {
            return this.status === TSSchadenfallStatus.NEU || this.status === TSSchadenfallStatus.NEU_PAPIER_FS ||
                this.status === TSSchadenfallStatus.NEU_PAPIER_ANLAUFSTELLE;   //papier hat neu_papier
        }
        return false;
    }

    public translateRechtsform(rechtsform: TSRechtsform): string {
        return this.$translate.instant('' + rechtsform);

    }

    public showFinanzVerhaeltnisse(): boolean {
        let benutzer: TSUser | undefined = this.authServiceRS.getPrincipal();
        // @ts-ignore
        if (benutzer.email === 'cnav@ne.ch' && !isInStatus(this.status, getTSSchadenfallStatusNeu())) {
            //FIXME FS-751: Temporary hack
            //Für das Unwetter in La Chaux-de-Fonds soll ein Benutzer als Drittperson Gesuche für andere erfassen können.
            //Die Steuerfaktoren sollen in diesem Fall ausgeblendet werden. Soll mit FS-750 generell gelöst werden.
            return false;
        }

        const notZweitperson = !this.model.isZweitperson;
        const isSteuerpflichtigeRechtsfrom = this.isSteuerpflichtigeRechtsform(this.model);

        return notZweitperson && isSteuerpflichtigeRechtsfrom;
    }

    private isSteuerpflichtigeRechtsform(gesuchsteller: TSGesuchsteller) {
        return gesuchsteller.rechtsform === TSRechtsform.NATUERLICHE_PERSON ||
            (gesuchsteller.rechtsform === TSRechtsform.GENOSSENSCHAFT
                && gesuchsteller.genossenschaft !== undefined
                && gesuchsteller.genossenschaft.genossenschaftDatenFS.isSteuerpflichtig);
    }

    public getJahrtext(rechtsform: TSRechtsform): string {
        return this.dvBernUtil.getJahrtext(rechtsform);
    }

    public getEinkommenGewinnText(rechtsform: TSRechtsform): string {
        return this.dvBernUtil.getEinkommenGewinnText(rechtsform);
    }

    public getVermoegenKapitalText(rechtsform: TSRechtsform): string {
        return this.dvBernUtil.getVermoegenKapitalText(rechtsform);
    }

    public getAngabenTitle(): string {
        switch (this.model.rechtsform) {
            case TSRechtsform.NATUERLICHE_PERSON:
                return this.$translate.instant(this.model.eigentumsverhaeltnis.toString());
            default:
                return this.$translate.instant(this.model.eigentumsverhaeltnis.toString()) + ' ' + this.$translate.instant(this.model.rechtsform.toString());

        }
    }

    public needDokuments(): boolean {
        return !!(this.model && this.dokumentNeededMap[this.model.rechtsform] && this.dokumentNeededMap[this.model.rechtsform].length > 0);
    }

    public countRequiredDocs(): string {
        let requiredDocs: number = 0;
        if (this.needDokuments()) {
            for (let dokumentNeeded of this.dokumentNeededMap[this.model.rechtsform]) {
                if (dokumentNeeded[1]) {
                    requiredDocs++;
                }
            }
        }
        return '' + requiredDocs;
    }

    public isShowTitlePrefix(): boolean {
        return this.dvBernUtil.isShowTitlePrefix(this.model);
    }

    private steuerpflichtChanged(event: any) {
        this.loadDokumentNeededMap();
    }
}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-gesuchsteller/dv-gesuchsteller.ts